import { useSiteSettings } from "../../contexts/SiteSettingsContext";
import SiteHeader from "./components/SiteHeader";
import SiteFooter from "./components/SiteFooter";
import FC2Section from "./components/FC2Section";

export default function Home() {
  const { settings } = useSiteSettings();

  const affiliateId = (settings as Record<string, unknown>).fc2AffiliateId as string | undefined;
  const minPrice = (settings as Record<string, unknown>).fc2MinPrice as number | undefined ?? 3000;
  const limit = (settings as Record<string, unknown>).fc2Limit as number | undefined ?? 12;

  return (
    <div className="min-h-screen flex flex-col bg-[#fdf8fb]">
      <SiteHeader />

      <main className="flex-1 w-full">
        {/* ヒーローバナー */}
        <div className="w-full bg-gradient-to-r from-rose-700 via-rose-600 to-pink-600 py-8 px-4">
          <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="text-rose-200 text-xs font-medium mb-1 tracking-widest uppercase">FC2 Contents Market</p>
              <h1 className="text-white text-2xl md:text-3xl font-bold leading-tight">
                厳選アダルト作品ガイド
              </h1>
              <p className="text-rose-100 text-sm mt-2">
                3,000pt以上の高品質作品を毎日自動更新でお届け
              </p>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
              <div className="bg-white/10 rounded-xl px-4 py-3 text-center">
                <p className="text-white text-xl font-bold">{limit * 2}+</p>
                <p className="text-rose-200 text-xs">掲載作品</p>
              </div>
              <div className="bg-white/10 rounded-xl px-4 py-3 text-center">
                <p className="text-white text-xl font-bold">毎日</p>
                <p className="text-rose-200 text-xs">自動更新</p>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 py-8">

          {/* 新作セクション */}
          <FC2Section
            type="new"
            title="新作"
            subtitle={`最新入荷 ${minPrice.toLocaleString()}pt以上の新作作品`}
            affiliateId={affiliateId}
            minPrice={minPrice}
            limit={limit}
            accentColor="#e11d48"
          />

          {/* 区切り */}
          <div className="w-full h-px bg-gradient-to-r from-transparent via-rose-200 to-transparent mb-12" />

          {/* おすすめセクション */}
          <FC2Section
            type="recommended"
            title="おすすめ"
            subtitle={`高報酬率商品 ${minPrice.toLocaleString()}pt以上のおすすめ作品`}
            affiliateId={affiliateId}
            minPrice={minPrice}
            limit={limit}
            accentColor="#d97706"
          />

          {/* アフィリエイト注記 */}
          <div className="mt-4 mb-8 text-center">
            <p className="text-xs text-gray-400">
              ※ 本サイトはFC2コンテンツマーケットのアフィリエイトプログラムに参加しています。
              商品リンクをクリックして購入された場合、当サイトに報酬が発生することがあります。
            </p>
          </div>

        </div>
      </main>

      <SiteFooter />
    </div>
  );
}
